import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';

import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import TripReviewService from '../../api/services/TripReviewService';

const UploadTutorialList = () => {
    const [Error, setError] = useState('');

    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL + 'Tripplan/';
    const [UploadedList, setUploadedList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setisloading] = useState(true);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = UploadedList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(UploadedList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }


    const getUploadedList = async () => {

        try {
            let responseData = await TripReviewService.tripplan().json()
            setUploadedList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getUploadedList();

        }
        else {
            navigate('/');
        }

    }, [])

    return (
        <>
            <MainPagetitle mainTitle="Travel Planner" pageTitle={'Travel Planner'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0"> Travel Planner</h4>

                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Title</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Description</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Image</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Price</strong>
                                                    </th>
                                                    <th style={{ textAlign: 'left' }}><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>
                                                                    {element.title}

                                                                </td>
                                                                <td>
                                                                    <p
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: element.description,
                                                                        }}
                                                                    ></p>

                                                                </td>
                                                                <td>
                                                                    <img className="img-drop-area" height={element.image ? 50 : 0} width={element.image ? 50 : 0} src={element.image ? imageUrl + element.image : "voucher"} alt='voucher' />
                                                                </td>
                                                                <td>
                                                                    {element.price}
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Link
                                                                            to={`/admin/edit-travel/${element.id}`}
                                                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                                                        >
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        </Link>

                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {UploadedList.length < lastIndex ? UploadedList.length : lastIndex}
                                                {" "}of {UploadedList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default UploadTutorialList;
